import type { ProductRequestSchemas } from "api-types";
import { http, HttpResponse } from "msw";

export const exampleNewOffersRequestStatus: ProductRequestSchemas.NewOffersRequestStatusResponse = {
  hasCustomerRequestedNewOffers: false,
};

export const createNewOffersRequestStatusHandler = (response: ProductRequestSchemas.NewOffersRequestStatusResponse) => {
  return http.get("/api/*/product-request/api/*/new-offers-request-status", () => HttpResponse.json(response));
};

export const getNewOffersRequestStatusHandler = createNewOffersRequestStatusHandler(exampleNewOffersRequestStatus);
